import {useState, useEffect} from 'react';
import request from 'superagent';
import config from '../../shared/config';
import {signOut} from '../../shared/auth';
import url from 'url';
import kindof from 'kind-of';

import {makeLabel} from "./shared";

function apiURL(endPoint, ...path) {
	let baseURL = config.get('CentralConfigurationURL');
	let services = config.get('ServiceConfiguration.services', []);
	let customer, environment;
	try {
		({customer, environment} = services[0]);
	} catch (error) {
		throw new Error(`Service Configuration doesn't have a services configured properly`);
	}
	path = ['api', 'v1', 'ingressControl', endPoint, customer, environment, ...path];
	return url.resolve(baseURL, path.join('/'));
}

let _rateFields = null;

function isRateField(k, v) {
	if (!_rateFields) {
		let {rates} = config.get('ServiceConfiguration');
		_rateFields = new Set(Array.from(rates).map(([f]) => makeLabel(f)[0]));
	}
	return _rateFields.has(k) && kindof(v) === 'object';
}

let _filterFields = null;

function isFilterField(k) {
	if (!_filterFields) {
		let {filters} = config.get('ServiceConfiguration');
		_filterFields = new Set(Array.from(filters).map(([f]) => makeLabel(f)[0]));
	}
	return _filterFields.has(k);
}

let _editableFields = new Set(['displayName']);

function convertServerRule(rule) {
	return rule;
}

async function listRules() {
	let url = apiURL('rates');
	let response, rules;

	try {
		response = await request
			.get(url)
			.set('x-access-token', config.get('token'));
	} catch (err) {
		if (err && err.status === 401) {
			signOut();
		}
		throw err;
	}

	try {
		rules = response.body.service;
	} catch (err) {
		return {};
	}
	let re = {};
	for (let [k, rule] of Object.entries(rules)) {
		re[k] = convertServerRule(rule);
	}
	return re;
}

async function loadRule(ruleId) {
	let rules = await listRules();
	return rules[ruleId];
}

function * convertValueToJSONPatch(k, v) {
	if (isRateField(k, v)) {
		for (let [option, value] of Object.entries(v)) {
			yield {op: 'replace', path: `/${k}/${option}`, value};
		}
	} else if (_editableFields.has(k)) {
		yield {op: 'replace', path: `/${k}`, value: v};
	}
}

async function saveRule(ruleId, data) {
	let {rates} = config.get('ServiceConfiguration');
	for (let [r] of rates) {
		let [ruleField] = makeLabel(r);
		let ratesToSave = data[ruleField];
		if (kindof(ratesToSave) !== 'object') {
			continue;
		}
		let url = apiURL('rates', ruleId, ruleField);
		await request
			.patch(url)
			.set('x-access-token', config.get('token'))
			.type('json')
			.send(ratesToSave);
	}
}

function useRulesData(apiMethod) {
	let [data, setData] = useState(null);
	let [loading, setLoading] = useState(false);
	useEffect(() => {
		if (data === null && !loading) {
			setLoading(true);
			(async () => {
				let d = await apiMethod();
				setData(d);
				setLoading(false);
			})();
		}
	});
	return [loading || (data === null), data, setData];
}


export {useRulesData, listRules, loadRule, saveRule};